import { render, staticRenderFns } from "./Logactivity.vue?vue&type=template&id=112330e8&scoped=true&"
import script from "./Logactivity.vue?vue&type=script&lang=js&"
export * from "./Logactivity.vue?vue&type=script&lang=js&"
import style0 from "./Logactivity.vue?vue&type=style&index=0&id=112330e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112330e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VPagination})
